import React from 'react';
import { Button, FormInput, FormTextarea, Message } from '@getro/rombo';
import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';

import { useCompaniesFormValidation } from '../hooks/useCompaniesFormValidation';

const CompaniesCreate = ({ formRef, formDefaultValues, isEdit, isUpdatingList, isSubmitting, onSubmit, isError }) => {
  const { onFormValidation } = useCompaniesFormValidation();

  const onCurrentSubmit = async (values) => {
    const domains = values.domains.split(/[\n,]+/);
    const domainsArray = domains.filter((domain) => domain.trim().length > 0);

    onSubmit({ ...values, domains: domainsArray });
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={{ domains: '', ...formDefaultValues }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onCurrentSubmit}
      validate={onFormValidation}
    >
      {({ values }) => (
        <Box
          as={Form}
          width="100%"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <Field
            autoFocus
            component={FormInput}
            name="name"
            label="Name"
            labelExtra="Required"
            sx={{
              fontSize: '14px',
            }}
          />
          <Field
            containerProps={{
              sx: {
                'div[color="danger"]': {
                  bg: 'red.20',
                  p: '8px',
                  '& > div': {
                    p: '0px',
                  },
                },
              },
            }}
            type="text"
            name="domains"
            component={FormTextarea}
            value={values?.domains?.replace(/,/g, '\n')}
            height="120px"
            placeholder={`website1.com\nwebsite2.com\nwebsite3.com\n...`}
            label="Companies websites"
            helpText="Enter the websites of the companies you want to add, one per line or separated by commas. You can easily copy and paste them from a spreadsheet."
          />
          {isEdit ? (
            <Flex justifyContent="flex-start" mt="8px">
              <Button type="submit" loading={isUpdatingList} size="small">
                Update
              </Button>
            </Flex>
          ) : (
            <Flex justifyContent="flex-start" mt="8px">
              <Button type="submit" loading={isSubmitting} size="small">
                Create companies list
              </Button>
            </Flex>
          )}

          {isError && (
            <Message type="error" title="Invalid website format">
              There was an unexpected error, please try again or{' '}
              <Box as="a" href="mailto:help@getro.com">
                contact us
              </Box>
              .
            </Message>
          )}
        </Box>
      )}
    </Formik>
  );
};

CompaniesCreate.propTypes = {
  formRef: PropTypes.object,
  formDefaultValues: PropTypes.object,
  isEdit: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  isUpdatingList: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isError: PropTypes.bool,
};

CompaniesCreate.defaultProps = {
  formRef: null,
  formDefaultValues: {},
  isEdit: false,
  isUpdatingList: false,
  isSubmitting: false,
  isError: false,
};

export default CompaniesCreate;
